// extracted by mini-css-extract-plugin
module.exports = {"documentInfoContainer":"DocumentInfoLists_documentInfoContainer__2-tAS","documentInfoItem":"DocumentInfoLists_documentInfoItem__3lu2_"};